module.exports = __webpack_public_path__ + "media/images/gifts/art/sug_arte_7-4b3c0fea7c54135e7516a06db47629e9.jpg";